import {combineReducers} from 'redux'
import {SeatingState} from '../../types/state'
import errors from './errors'
import filters from './filters'
import loading from './loading'
import mode from './mode'
import places from './places'
import plan from './plan'

export const seating = combineReducers<SeatingState>({
  plan,
  loading,
  errors,
  places,
  filters,
  mode,
})
